import { useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  IconButton,
  Stack,
  Typography
} from '@mui/material';
import MGCViewOnly from '../shared/MGCViewOnly';
import CreateMGC from '../filters/MGCHierarchyFilter';
import WarningErrorIcon from './WarningErrorIcon';

export default function MgcWrapper(props) {
  const [isMgcEditView, setIsMgcEditView] = useState(false);
  const [isMgcEdited, setIsMgcEdited] = useState(false);

  function toggleMgcEdit(currentMgc) {
    let disableViewSwitch =
      !props.selectedMgc ||
      !props.selectedMgc.commodity ||
      !props.selectedMgc.major;
    if (isMgcEditView && disableViewSwitch) {
      return;
    }
    if (isMgcEdited && !isMgcEditView) {
      props.resetSelectedMgcAfterEdit(currentMgc);
    }
    if (isMgcEditView) {
      setIsMgcEdited(true);
    }
    setIsMgcEditView(!isMgcEditView);
  }

  function buildSelectedMGCJsonFromSelectedMgc(
    commodity,
    major,
    minorSegments
  ) {
    let checkedParentMinors = [];
    let checkedChildren = [];
    if (minorSegments) {
      commodity &&
        major &&
        minorSegments.map((item) =>
          item.checked
            ? checkedParentMinors.push(
                commodity.value + major.value + item.code
              )
            : ''
        );
      commodity &&
        major &&
        minorSegments.map((item) =>
          item.checked || item.indeterminate
            ? item.children &&
              item.children.map((seg) =>
                seg.checked
                  ? checkedChildren.push(
                      commodity.value + major.value + item.code + seg.code
                    )
                  : ''
              )
            : ''
        );
    }

    return {
      commodities: commodity ? [commodity.value] : [],
      majors: major ? [major.value] : [],
      parent: checkedParentMinors,
      children: checkedChildren
    };
  }

  return (
    <Card>
      <CardContent>
        <Stack direction="row" alignItems="center" spacing={1}>
          {!props.isNewForm && props.isEditable && (
            <IconButton
              aria-label={isMgcEditView ? 'exit edit mode' : 'edit'}
              size="small"
              color={isMgcEditView ? 'primary' : 'default'}
              onClick={() => toggleMgcEdit(props.selectedMgc)}
              sx={(theme) => ({
                borderRadius: theme.fuel6Tokens.JddcRadiusSmall,
                flexShrink: 0,
                ...(isMgcEditView && { bgcolor: 'action.selected' })
              })}
            >
              <fuel-icon name="edit" />
            </IconButton>
          )}
          <Typography variant="h3">
            {props.label}
            {props.isEditable && isMgcEditView && (
              <Box component="span" sx={{ color: 'text.secondary', ml: 1 }}>
                (Edit Mode)
              </Box>
            )}
            <WarningErrorIcon state={props.duplicateStrategyState} />
          </Typography>
        </Stack>

        <Box sx={(theme) => ({ mt: theme.fuel6Tokens.JddcSpacingMedium })}>
          {!props.isNewForm && props.isEditable && !isMgcEditView ? (
            props.masterMGCJson &&
            props.strategyInformation && (
              <Box>
                <MGCViewOnly
                  strategyInformation={props.strategyInformation}
                  masterData={props.masterMGCJson}
                  isMgcEdited={isMgcEdited}
                  selectedMgc={props.selectedMgc}
                  editStrategy={true}
                />
              </Box>
            )
          ) : (
            <CreateMGC
              masterMGCJson={props.masterMGCJson}
              createMGC={true}
              register={props.register}
              setParentMgcData={props.setParentMgcData}
              selectedMGCList={props.selectedMGCList}
              commonProps={props.commonProps}
              isEdit={props.isEditable}
              isEditMgc={!props.newForm ? isMgcEditView : false}
              selectedMgcsUpdated={props.selectedMgcsUpdated}
              showMgcError={
                isMgcEditView || props.selectedMgcsUpdated || props.saveMgcError
              }
              isMgcEdited={isMgcEdited}
              selectedMgcAfterEdit={props.selectedMgcAfterEdit}
              selectMgcJsonAfterEdit={
                props.selectedMgcAfterEdit
                  ? buildSelectedMGCJsonFromSelectedMgc(
                      props.selectedMgcAfterEdit.commodity,
                      props.selectedMgcAfterEdit.major,
                      props.selectedMgcAfterEdit.minorSegments
                    )
                  : null
              }
              selectedMgc={props.selectedMgc}
              isNewForm={props.isNewForm}
            />
          )}
        </Box>
      </CardContent>
    </Card>
  );
}
